<div class="center">
  <iui-messages #messages class="ms-auto me-auto"></iui-messages>
</div>
<div class="container">

  <div class="row">
    <div class="col-6">
      <h2 *ngIf="!submitted">Forgot User ID</h2>
      <h2 *ngIf="submitted">Retrieve User ID Confirmation</h2>
    </div>
  </div>
  <div *ngIf="!submitted" class="row">
    <div class="offset col-md-4">
      The system will send your user id to the email address on record. Please enter your email address.
    </div>
    <form #forgotUserNameForm="ngForm" (ngSubmit)="submit()" class="offset-1 col-4">
      <div class="mb-3 justify-content-center ps-5 pe-5 pt-3">
        <label for="email" class="required" i18n id="emailLabel">Email</label>
        <input appEmailValidator appEmail id="email" name="email" required class="form-control" placeholder="Email" maxlength="{{MaxLen.Email}}" [(ngModel)]="emailaddress"
          #email="ngModel" />
        <app-error-msg [field]="email"></app-error-msg>
      </div>

      <div class="mb-3 justify-content-center mt-4 d-flex">
        <button [disabled]="forgotUserNameForm.invalid" type="submit" class="btn btn-primary px-4 mb-2">Retrieve User ID</button>
        <app-help-link-icon [helpPath]="'ForgotUserID'" [customClass]="'ms-1 align-top float-end'"></app-help-link-icon>
      </div>

      <div class="mb-3 justify-content-center mt-4 d-flex">
        <a [routerLink]="'/sec/forgotpassword'" class="pt-2 link color-blue" i18n id="forgotPWLink">Forgot Password</a>
      </div>
      <hr />
      <div class="mb-3 justify-content-center mt-4 d-flex">
        If you need help please contact&nbsp;<a class="" href="{{customerSupportLink}}">Customer Support</a>
      </div>
    </form>
  </div>
  <div *ngIf="submitted" class="row">
    <div class="col-5 mx-auto">
      <p>
        If you entered a valid email address then your user id has been sent to the email address on record. Please click here to
        <a class="" href="/sec/login">login</a>.
      <p>
        If you do not receive an email within a few minutes, then please contact
        <a href="{{customerSupportLink}}">Customer Support</a>.

    </div>
  </div>
</div>